<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "chat", attrs: { sm: "6" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "b-modal",
                rawName: "v-b-modal.modal-chat-window-open",
                modifiers: { "modal-chat-window-open": true },
              },
            ],
            staticClass: "chat-button",
          },
          [_c("Message")],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-chat-window-open",
            size: "md",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "chat-b-r" },
            [_c("Chat", { attrs: { counterUserData: _vm.counterUserData } })],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/buy-sell/Chat.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_message_svg from '@/assets/rashi-coin/message.svg';
import core_components_chat_Message_vue from '@core/components/chat/Message.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    BCard: bootstrapvue["BCard"],
    BContainer: bootstrapvue["BContainer"],
    BButton: bootstrapvue["BButton"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    Chat: core_components_chat_Message_vue,
    Message: assets_rashi_coin_message_svg,
    BModal: bootstrapvue["BModal"]
  },
  props: {
    counterUserData: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  data() {
    return {
      showCancelOrderPop: false
    };
  }
});

//# sourceURL=webpack:///./src/layouts/components/buy-sell/Chat.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.payment-show {
  display: flex;
  align-items: center;
}
.timer-color {
  color: var(--primary);
}
.order-created .order-created-text {
  color: #707a8a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.order-created .payment-method {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
.order-created .vertical-red-line {
  display: inline-block;
  width: 2px;
  height: 12px;
}
[dir] .order-created .vertical-red-line {
  border: 2px solid #f7984a;
  margin: 0px 5px -2px 5px;
  border-radius: 4px;
  background: #f7984a;
}
.order-created .trusted-rudra {
  height: fit-content;
}
[dir] .order-created .trusted-rudra {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 0;
}
.dispute {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
.dispute-text {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.ol-text {
  color: var(--text-black-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
}
@media (min-width: 430px) and (max-width: 991px) {
[dir] .order-num {
    margin-top: 16px;
}
}
@media (min-width: 991px) {
.chat {
    display: none;
}
}
@media (max-width: 991px) {
.chat {
    height: 5vh;
}
}
[dir] .chat-b-r {
  margin-top: -10px;
}
</style>
